"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerSignature = exports.rsvSig = exports.LedgerAddress = exports.LedgerDeviceInfo = exports.LedgerVersion = exports.LedgerAppName = void 0;
/**
 * @class LedgerAppName
 * {@link LedgerAppName}
 */
class LedgerAppName {
    constructor(name) {
        this.name = name;
    }
}
exports.LedgerAppName = LedgerAppName;
/**
 * @class LedgerVersion
 * {@link LedgerVersion}
 */
class LedgerVersion {
    constructor(major, minor, patch) {
        this.major = major;
        this.minor = minor;
        this.patch = patch;
    }
}
exports.LedgerVersion = LedgerVersion;
/**
 * @class LedgerDeviceInfo defines the Device info returned by the client
 * {@link LedgerDeviceInfo:class}
 */
class LedgerDeviceInfo {
}
exports.LedgerDeviceInfo = LedgerDeviceInfo;
/**
 * @class LedgerAddress defines the Wallet info returned by the client
 * {@link LedgerAddress:class}
 */
class LedgerAddress {
    constructor(publicKey, address, chainCode) {
        this.address = address;
        this.publicKey = publicKey;
        this.chainCode = chainCode;
    }
}
exports.LedgerAddress = LedgerAddress;
class rsvSig {
    constructor() {
        this.r = new Uint8Array(32);
        this.s = new Uint8Array(32);
        this.v = new Uint8Array(1);
    }
    fromDER(signature, parityOdd) {
        if (signature.length < 72) {
            throw new Error("invalid signature length to convert der signature to rsv format");
        }
        let offset = 0;
        let xoffset = 4; // point to r value
        // copy r
        let xlength = signature[xoffset - 1];
        if (xlength == 33) {
            xlength = 32;
            xoffset++;
        }
        this.r.set(signature.slice(offset + 32 - xlength, xoffset));
        offset += 32;
        xoffset += xlength + 2; // move over rvalue and TagLEn
        // copy s value
        xlength = signature[xoffset - 1];
        if (xlength == 33) {
            xlength = 32;
            xoffset++;
        }
        this.s.set(signature.slice(offset + 32 - xlength, xoffset));
        // set v
        if (parityOdd == true) {
            this.v[0] = 1;
        }
        else {
            this.v[1] = 0;
        }
    }
}
exports.rsvSig = rsvSig;
/**
 * @class LedgerSignature defines the Wallet info returned by the client
 * {@link LedgerSignature:class}
 */
class LedgerSignature {
    constructor(signature, v) {
        this.signature = signature;
        this.parityIsOdd = v;
    }
}
exports.LedgerSignature = LedgerSignature;
//# sourceMappingURL=results.js.map